import 'phaser';
import { language } from './language';
import { CST } from '../CST';
import BoardOnlyView from './boardViewOnly';

var clickSound;

export default class EndScreen extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.ENDSCREENCLIENT);
	}

	init() {}

	preload() {
		this.load.image('bg-end-game', 'assets/english/bg-end-game.png');
	}

	create(data) {
		let self = this;

		const chatChannel = new BroadcastChannel('chat_channel');

		chatChannel.onmessage = event => {
			const data = JSON.parse(event.data);

			switch (data.action) {
				case 'replay':
					window.close();
					break;
				case 'home':
					window.close();
					break;
			}
		};

		clickSound = this.sound.add('clickSound');

		this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bg-end-game')
			.setScale(1);

		if (data.scene === CST.SCENES.BOARDONLYVIEW) {
			this.scene.remove(CST.SCENES.BOARDONLYVIEW);
			this.scene.add(CST.SCENES.BOARDONLYVIEW, BoardOnlyView, false);
		}
	}
}
